import { render, staticRenderFns } from "./IndexNews.vue?vue&type=template&id=19636202&"
import script from "./IndexNews.vue?vue&type=script&lang=js&"
export * from "./IndexNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports